import { api } from './api';

export const copilotApi = {
  chat: (session_id, message) => api.post('/copilot/chat', { session_id, message }),
  confirm: (session_id, pending_id) => api.post('/copilot/confirm', { session_id, pending_id }),
  cancel: (session_id, pending_id) => api.post('/copilot/cancel', { session_id, pending_id }),
  history: (session_id) => api.get(`/copilot/history/${session_id}`),
  insights: (doctype, recordId) => api.get(`/copilot/insights/${doctype}/${encodeURIComponent(recordId)}`),
};
